export class SendOtpRequest {
  mobileNumber: string | undefined;
}
export class CheckOtpRequest {
  referenceNumber: string | undefined;
  otp: string | undefined;
}
export interface CheckOtpResponse {
  jwt: string;
  isSuperUser: boolean;
}

export interface TokenClaimModel {
  supplierId: number;
  mobileNumber: number;
  supplierName: string;
  isActive: boolean;
  isSuperUser: boolean;
  canModifyUser: boolean;
  exp: number;
}
// todo new
export class AuthenticateRequest {
  // referenceKey: string | undefined;
  username: string | undefined;
  password: string | undefined;
}

export interface AuthenticateResponse {
  jwt: string;
  isSuperUser: boolean;
  forceChangePassword: boolean;
}

export interface ChangePasswordRequest {
  oldPassword: string;
  newPassword: string;
}
export class GetSideMenu {
  subMenus: SubMenus[] | undefined;
}
export class SubMenus {
  id: number | undefined;
  title: string | undefined;
  name: string | undefined;
  icon: string | undefined;
  route: string | undefined;
  parentId: number | undefined;
  subMenus: SubMenus[] | undefined;
  menuMapRoute: string | undefined;
}

export interface ChangeUserPasswordByAdminRequest {
  newPassword: string;
  userId: number;
}
export interface UpdateUserRequest {
  firstName: string;
  lastName: string;
  username: string;
  mobileNumber?: string;
  userId: number | null;
  gender?: "Male" | "Female";
  isSystemUser?: boolean;
  notificationEnabled?: boolean;
  isAdmin?: boolean;
  isActive?: boolean;
}

export interface GetUsersRequest {
  paginationInfo: PaginationInfo;
  filter?: UsersFilter;
}

export interface PaginationInfo {
  pageNumber: number;
  pageSize: number;
}
export interface UsersFilter {
  mobileNumber: string;
  firstName: string;
  lastName: string;
  username: string;
  notificationEnabled: boolean | undefined;
  genderType?: "Male" | "Female";
  isSystemUser: boolean | undefined;
  createDateTime?: Date[] | null | string;
  isActive: boolean | undefined;
}

export interface GetUsersResponse {
  id: number;
  mobileNumber: string;
  firstName: string;
  lastName: string;
  username: string;
  isActive: boolean;
  notificationEnabled: boolean;
  genderType: "Male" | "Female";
  isSystemUser: boolean;
  createDate: Date;
  createDatePersian: string;
  isAdmin?: boolean;
}

export interface RegisterUserRequest {
  gender: "Male" | "Female";
  isSystemUser: boolean;
  notificationEnabled: boolean;
  firstName: string;
  lastName: string;
  username: string;
  mobileNumber?: string;
  isAdmin?: boolean;
}
